import React from 'react';
import person from '../assets/portfolio_dp_2.jpg';
import resume from '../assets/sachintha_rathnayake_resume.pdf';
import CustomButton from './CustomButton';

export const BioSection = ({ theme }) => {
  const bioContent = {
    fontSize: theme.isMobile ? 20 : 22,
    color: theme.darkColor,
    fontWeight: 500,
    marginTop: theme.isMobile ? 20 : 0,
  };

  const bioDetailsKey = {
    fontSize: theme.isMobile ? 18 : 22,
    color: theme.darkerColor,
    fontWeight: 600,
  };

  const bioDetailsValue = {
    fontSize: theme.isMobile ? 18 : 22,
    color: theme.darkerColor,
    fontWeight: 300,
  };

  const personImage = {
    width: theme.isMobile ? '100%' : 365,
    borderRadius: 10,
    margin: 'auto',
  };

  const handleDownloadPDF = () => {
    const anchor = document.createElement('a');
    anchor.href = resume;
    anchor.target = '_blank';
    anchor.download = 'sachintha_rathnayake_cv.pdf';
    anchor.click();
  };

  return (
    <div id='bio-section' className='section'>
      <div
        className='text-center sub-heading'
        style={{ color: theme.darkerColor }}
      >
        About Me
      </div>
      <div className='row'>
        <div className='col-md-4 d-flex'>
          <img src={person} style={personImage} alt='profile'></img>
        </div>
        <div className='col-md-8'>
          <div style={bioContent}>
            Enthusiastic Software Engineer with 3+ years of experience and a
            passion for emerging technologies. Strong team player with excellent
            communication and project management skills. Expertise in full-stack
            development, NLP, image processing, data structures and algorithms,
            and data analytics. Eager to explore innovative research in Computer
            Science.
          </div>
          <div className='row mt-3'>
            <div className='col-4 col-md-3' style={bioDetailsKey}>
              <div> Name: </div>
            </div>
            <div className='col-8 col-md-9' style={bioDetailsValue}>
              <div> Sachintha Rathnayake </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-4 col-md-3' style={bioDetailsKey}>
              <div> {theme.isMobile ? 'DOB' : 'Date of birth:'} </div>
            </div>
            <div className='col-8 col-md-9' style={bioDetailsValue}>
              <div> April 27, 1995</div>
            </div>
          </div>
          <div className='row'>
            <div className='col-4 col-md-3' style={bioDetailsKey}>
              <div> Address:</div>
            </div>
            <div className='col-8 col-md-9' style={bioDetailsValue}>
              <div> Kotugoda, Sri Lanka</div>
            </div>
          </div>
          <div className='row'>
            <div className='col-4 col-md-3' style={bioDetailsKey}>
              <div> Email:</div>
            </div>
            <div className='col-8 col-md-9' style={bioDetailsValue}>
              <div> sacheerc@gmail.com</div>
            </div>
          </div>
          <div className='row'>
            <div className='col-4 col-md-3' style={bioDetailsKey}>
              <div>Phone:</div>
            </div>
            <div className='col-8 col-md-9' style={bioDetailsValue}>
              <div> +94 719 247080</div>
            </div>
          </div>
          <CustomButton
            height={46}
            borderRadius={50}
            fontSize={24}
            fontWeight={400}
            color={theme.lighterColor}
            backgroundColor={theme.primaryColor}
            marginTop={30}
            onClick={handleDownloadPDF}
            theme={theme}
          >
            Download CV
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
